// 模块化vuex数据
// getter调用示例：this.$store.getters['moduleA/moduleState']

const state = {
  cutAudios: []
};

const getters = {
  cutAudios: (state) => state.cutAudios
};

const mutations = {
  addCutAudios(state, data) {
    state.cutAudios.push(data);
  },
  removeAudioIndex(state, index) {
    state.cutAudios.splice(index, 1);
  },
  clearCutAudios(state) {
    state.cutAudios = [];
  }
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
